import { get, post, put, patch } from './_httpClient';

export async function getVECIIdentity() {
  return get('/clp/bumdes/survey-veci/identity');
}

export async function getVECIQuestions() {
  return get('/clp/bumdes/survey-veci/questions');
}

export async function submitVECISurvey(payload) {
  return post('/clp/bumdes/survey-veci', payload);
}

export async function saveDraftVECISurvey(payload) {
  return post('/clp/bumdes/survey-veci/draft', payload);
}

export async function updateDraftVECISurvey(surveyId, payload) {
  return put(`/clp/bumdes/survey-veci/draft/${surveyId}`, payload);
}

export async function getVECISurveyResult(surveyId) {
  return get(`/clp/bumdes/survey-veci/results/${surveyId}`);
}

export async function getMeBumdesVECIResult() {
  return get('/clp/bumdes/survey-veci/me/result');
}

export async function getVECISurveyComparison() {
  return get('/clp/bumdes/survey-veci/comparison');
}

export async function checkVECIAnomalies(payload) {
  return post('/clp/bumdes/survey-veci/check-anomalies', payload);
}

export async function getVECISurveyResults() {
  return get('/clp/bumdes/survey-veci/results');
}

export async function getVECISurveys({ batchId, orderBy = 'newest' }) {
  return get(`/clp/admin/bumdes/survey-veci?batchId=${batchId}&orderBy=${orderBy}`);
}

export async function getVECISurveyDetail(surveyId) {
  return get(`/clp/admin/bumdes/survey-veci/${surveyId}`);
}

export async function updateVECISurveyStatus(surveyId, payload) {
  return patch(`/clp/admin/bumdes/survey-veci/${surveyId}/status`, payload);
}

export async function getVECIHeatmap({ batchId }) {
  return get(`/clp/admin/bumdes/survey-veci/heatmap?batchId=${batchId}`);
}

export async function getVECIDashboard({ batchId }) {
  return get(`/clp/admin/bumdes/survey-veci/dashboard?batchId=${batchId}`);
}

export async function getSurveyIdentity({ institutionId }) {
  return get(`/clp/admin/bumdes/survey-veci/identity?institutionId=${institutionId}`);
}

export async function submitSurveyVECI(payload) {
  return post('/clp/admin/bumdes/survey-veci', payload);
}
